import React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@totalsoft/rocket-webapp-components-deprecated";
import { CardContent, Grid, makeStyles, Typography } from "@material-ui/core";
import { emptyString } from "constants/defaultValues";
import styles from "../styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(styles);

function CompanyData({ quote }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignContent="center">
          <Grid item xs={12}>
            <Typography variant="h4">{t("DataCompletion.CompanyData")}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.CompanyName")}</Typography>
            <Typography className={classes.reducedFont}>{quote.quoteHeaderPartnerName || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.LegalForm")}</Typography>
            <Typography className={classes.reducedFont}>{quote.legalFormName || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Typography className={classes.minFont}>{t("DataCompletion.Owner")}</Typography>
            <Typography className={classes.reducedFont}>{quote.ownerName || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.StreetAddress")}</Typography>
            <Typography className={classes.reducedFont}>{quote.street || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.CityStateZip")}</Typography>
            <Typography className={classes.reducedFont}>
              {"(" +
                (quote.city ? quote.city + " / " : emptyString) +
                (quote.district ? quote.district + " / " : emptyString) +
                (quote.zipCode ? quote.zipCode : emptyString) +
                ")"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Typography className={classes.minFont}>{t("DataCompletion.Country")}</Typography>
            <Typography className={classes.reducedFont}>{quote.country || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.PhoneNr")}</Typography>
            <Typography className={classes.reducedFont}>{quote.phone || emptyString}</Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.minFont}>{t("DataCompletion.TaxIdNumber")}</Typography>
            <Typography className={classes.reducedFont}>{quote.partnerUniqueId || emptyString}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

CompanyData.propTypes = {
  quote: PropTypes.object.isRequired,
};

export default CompanyData;
